import React, { createContext, useContext } from "react";
import { useUsersManagement } from "@/hooks/admin/Users/useUsersManagement";

type UsersManagementContextType = ReturnType<typeof useUsersManagement>;

const UsersManagementContext = createContext<UsersManagementContextType | null>(null);

export const useUsersManagementContext = () => {
  const context = useContext(UsersManagementContext);
  if (!context) {
    throw new Error('useUsersManagementContext must be used within a UsersManagementProvider');
  }
  return context;
};

export const UsersManagementProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const usersManagementState = useUsersManagement();
  return (
    <UsersManagementContext.Provider value={usersManagementState}>
      {children}
    </UsersManagementContext.Provider>
  );
};